import { runClientComponent } from '../../_common/client/client-component-runner';
import { CustomerReviewSubmissionPageComponent } from './customer-review-submission-page.component';

runClientComponent({ CustomerReviewSubmissionPageComponent });
